type AppliedStateNodeWithPaths = {
  patchPath?: string | null;
  filePath?: string | null;
};

export const getPatchPath = (node: AppliedStateNodeWithPaths | undefined): string => {
  if (!node) return '';

  // Remove the protocol part from the patchPath if provided
  const path = node.patchPath?.split('://')[1] || node.filePath || '';
  return path;
};
